import {Body, H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import React from "react"
import styled, {css} from "styled-components"
import {useStoreContext} from "../../context/StoreContext"
import {useFeaturedCategoriesQuery} from "@irati/payrollpay/hooks"
import {transformToTrending} from "../../utils/transformToTrending"
import {StyledRouterLink} from "../../components/shared/StyledLink"
import Loading from "@irati/ui/src/Loading"

interface StoreHomeEmployeeOrganisation {
  employeeOrganisation?: {
    scheme?: {
      featuredCategories?: Array<{
        imageUrl?: string
        link?: string
        label?: string
      }>
    }
  }
}

export const Trending = () => {
  const {schemeType} = useStoreContext()
  const scheme = {schemeType}

  const {data, load} = useFeaturedCategoriesQuery(scheme, {
    fetchPolicy: "cache-and-network"
  })

  const trending = transformToTrending(
    (data as unknown as StoreHomeEmployeeOrganisation)?.employeeOrganisation?.scheme?.featuredCategories || [],
    schemeType
  )

  return (
    <Loading load={load}>
      <H2>
        <FormattedMessage id="platform.payrollpay.store.landing.he.trending" />
      </H2>
      <Grid>
        {trending.map((item, index) => (
          <StyledRouterLink to={`/${item.relativePath}`} key={index}>
            <TrendingCard key={index}>
              <TrendingImage src={item.imageUrl} alt={item.name} />
              <Body small textAlign="center">
                {item.name}
              </Body>
            </TrendingCard>
          </StyledRouterLink>
        ))}
      </Grid>
    </Loading>
  )
}

const Grid = styled.div`
  ${({theme}) => css`
    display: grid;
    gap: ${theme.spacing.one};
    margin: ${theme.spacing.two} auto;
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;

    ${theme.mediaQueries.minWidthMedia.desktop`
    gap: ${theme.spacing.two};
    grid-template-columns: repeat(3, 1fr);
    `}
    ${theme.mediaQueries.minWidthMedia.largeDesktop`
      grid-template-columns: repeat(4, 1fr);
    `}
    ${theme.mediaQueries.minWidthMedia.extraLargeDesktop`
      grid-template-columns: repeat(5, 1fr);
    `}
  `}
`

const TrendingCard = styled.div`
  ${({theme}) => css`
    width: 43vw;
    max-width: 175px;
    height: 169px;
    background: ${theme.colors.greys.white};
    border-radius: ${theme.border.radius.large};
    box-shadow: ${theme.shadows.mid};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: ${theme.spacing.two};

    ${theme.mediaQueries.minWidthMedia.desktop`
      max-width: unset;
      width: 207px;
      height: 286px;
    `}
  `}
`

const TrendingImage = styled.img`
  ${({theme}) => css`
    height: 100px;
    object-fit: contain;
    margin-bottom: ${theme.spacing.one};

    ${theme.mediaQueries.minWidthMedia.desktop`
    height: 175px;
    margin-bottom: 16px;
`}
  `}
`
